import React from 'react';
import { Link } from 'react-router-dom';
import { FaShippingFast, FaClock, FaShieldAlt, FaGlobe, FaBoxOpen, FaHeadset } from 'react-icons/fa';
import './Home.css';

function Home() {
  return (
    <main className="home">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-overlay"></div>
        <div className="container hero-content">
          <h1 className="hero-title">Professional Nationwide & European Delivery Solutions</h1>
          <p className="hero-subtitle">
            V&R Courier Ltd - Operating 24/7 with a focus on customer satisfaction. 
            From urgent same-day deliveries to full-load transport and house removals across the UK and Europe.
          </p>
          <div className="hero-buttons">
            <Link to="/quote" className="btn btn-primary">Get a Quote</Link>
            <Link to="/track" className="btn btn-outline">Track Shipment</Link>
          </div>
        </div>
      </section>

      {/* Promotional Banner */}
      <section className="promo-banner">
        <div className="container">
          <div className="promo-content">
            <div className="promo-main">
              <h2 className="promo-title">💰 Competitive Mileage Rates</h2>
              <p className="promo-text">Mileage rate starts from <strong>0.80p - 1.80p per mile</strong></p>
            </div>
            <div className="promo-offer">
              <div className="offer-badge">🎉 Special Offer</div>
              <p className="offer-text"><strong>15% OFF</strong> on first five bookings!</p>
            </div>
          </div>
          <Link to="/quote" className="btn btn-promo">Get Your Quote Now</Link>
        </div>
      </section>

      {/* Features Section */}
      <section className="features">
        <div className="container">
          <h2 className="section-title">Why Choose V&R Courier Ltd</h2>
          <p className="section-subtitle">
            Professional logistics solutions with 24/7 availability, nationwide coverage, and dedicated service
          </p>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">
                <FaShippingFast />
              </div>
              <h3>24/7 Availability</h3>
              <p>Always ready when you need us - immediate collection and rapid delivery nationwide</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">
                <FaClock />
              </div>
              <h3>Same Day Delivery</h3>
              <p>Urgent delivery with immediate collection - no delays or co-loading</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">
                <FaShieldAlt />
              </div>
              <h3>Dedicated Delivery</h3>
              <p>Your goods travel directly with no shared space for maximum security</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">
                <FaGlobe />
              </div>
              <h3>UK & European Coverage</h3>
              <p>Nationwide UK service plus door-to-door European road transport</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">
                <FaBoxOpen />
              </div>
              <h3>Real-Time Tracking</h3>
              <p>Know where your shipment is at every stage with live updates</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">
                <FaHeadset />
              </div>
              <h3>Professional Team</h3>
              <p>Trained, uniformed, and experienced drivers and handlers</p>
            </div>
          </div>
        </div>
      </section>

      {/* Services Overview */}
      <section className="services-overview">
        <div className="container">
          <h2 className="section-title">Our Services</h2>
          <p className="section-subtitle">
            Comprehensive courier and logistics solutions tailored to your needs
          </p>
          <div className="services-grid">
            <div className="service-card">
              <div className="service-image" style={{background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'}}></div>
              <div className="service-content">
                <h3>Same Day Delivery</h3>
                <p>Urgent delivery with immediate collection - picked up within the same day and delivered directly.</p>
                <Link to="/services" className="service-link">Learn More →</Link>
              </div>
            </div>
            <div className="service-card">
              <div className="service-image" style={{background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)'}}></div>
              <div className="service-content">
                <h3>Nationwide On-Call Service</h3>
                <p>UK-wide coverage with drivers ready to respond instantly for rapid collection and delivery.</p>
                <Link to="/services" className="service-link">Learn More →</Link>
              </div>
            </div>
            <div className="service-card">
              <div className="service-image" style={{background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)'}}></div>
              <div className="service-content">
                <h3>European Road Transport</h3>
                <p>Door-to-door road freight solutions across Europe for pallets and time-sensitive shipments.</p>
                <Link to="/services" className="service-link">Learn More →</Link>
              </div>
            </div>
            <div className="service-card">
              <div className="service-image" style={{background: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)'}}></div>
              <div className="service-content">
                <h3>House Moving & Removals</h3>
                <p>Professional domestic removal service with experienced teams for full household moves.</p>
                <Link to="/services" className="service-link">Learn More →</Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="stats">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-card">
              <h3>24/7</h3>
              <p>Always Available</p>
            </div>
            <div className="stat-card">
              <h3>UK Wide</h3>
              <p>Nationwide Coverage</p>
            </div>
            <div className="stat-card">
              <h3>Europe</h3>
              <p>International Transport</p>
            </div>
            <div className="stat-card">
              <h3>Direct</h3>
              <p>No Co-Loading</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <h2>Ready to Ship Your Package?</h2>
          <p>Get started with our reliable courier services today</p>
          <div className="cta-buttons">
            <Link to="/quote" className="btn btn-primary">Get Instant Quote</Link>
            <Link to="/contact" className="btn btn-secondary">Contact Us</Link>
          </div>
        </div>
      </section>
    </main>
  );
}

export default Home;

